class LapsPhotosModal {
	constructor() {
		this.modal = document.getElementById('laps-photos-modal');
		if (!this.modal) {
			return;
		}

		this.overlay = this.modal.querySelector('.laps-photos-modal__overlay');
		this.closeButton = this.modal.querySelector('.laps-photos-modal__close');
		this.modalTitle = this.modal.querySelector('.laps-photos-modal__title');
		this.sliderContainer = this.modal.querySelector('.laps-photos-modal__slides');
		this.sliderComponent = this.modal.querySelector('slider-component');

		this.articlesData = this.loadArticlesData();
		this.currentArticleId = null;

		this.bindEvents();
	}

	loadArticlesData() {
		const dataElement = document.getElementById('photographer-articles-data');
		if (!dataElement) {
			return [];
		}

		try {
			const data = JSON.parse(dataElement.textContent);
			return data;
		} catch (e) {
			return [];
		}
	}

	bindEvents() {
		// Close modal events
		if (this.closeButton) {
			this.closeButton.addEventListener('click', () => {
				this.close();
			});
		}

		if (this.overlay) {
			this.overlay.addEventListener('click', () => {
				this.close();
			});
		}

		// ESC key to close
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen()) {
				this.close();
			}
		});

		// Article card click events
		this.bindArticleCardEvents();
	}

	bindArticleCardEvents() {
		// For photographer blog template, bind click events to article cards
		const photographerLinks = document.querySelectorAll('.photographer-article-link');
		const photographerCards = document.querySelectorAll('[data-photographer-article="true"]');

		photographerLinks.forEach((link, index) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation(); // Stop event from bubbling to card handler
				const articleId = link.dataset.articleId;
				if (articleId) {
					this.open(articleId);
				}
			});
		});

		// Also allow clicking on the card itself (but not on other links inside it)
		photographerCards.forEach((card, index) => {
			card.addEventListener('click', (e) => {
				// Check if the click is on a photographer link - if so, let the link handler above deal with it
				if (e.target.closest('.photographer-article-link')) {
					return;
				}

				// Check if the click is on any other link (not photographer link)
				if (e.target.closest('a')) {
					return; // Allow normal link behavior for other links
				}

				// Click is on the card itself, not on any link - open modal
				e.preventDefault();
				const articleId = card.dataset.articleId;
				if (articleId) {
					this.open(articleId);
				}
			});
		});
	}

	open(articleId) {
		const articleData = this.articlesData.find(
			(article) => article.id === parseInt(articleId) || article.id === articleId.toString()
		);

		if (!articleData || !articleData.photos || articleData.photos.length === 0) {
			return;
		}

		this.currentArticleId = articleId;
		this.modalTitle.textContent = articleData.title;

		// Clear existing slides
		this.sliderContainer.innerHTML = '';

		// Add photos as slides
		articleData.photos.forEach((photo, index) => {
			const slide = document.createElement('li');
			slide.className = 'grid__item slider__slide laps-photos-modal__slide';
			slide.id = `Slide-photos-modal-${index + 1}`;

			const img = document.createElement('img');
			img.src = photo.src;
			img.srcset = photo.srcset;
			img.alt = photo.alt;
			img.width = photo.width;
			img.height = photo.height;
			img.loading = 'eager';
			img.className = 'laps-photos-modal__image';

			slide.appendChild(img);
			this.sliderContainer.appendChild(slide);
		});

		// Show modal
		this.modal.classList.add('laps-photos-modal--open');
		this.modal.setAttribute('aria-hidden', 'false');
		document.body.classList.add('overflow-hidden');

		// Re-initialize slider component after adding new slides
		if (this.sliderComponent) {
			setTimeout(() => {
				// Re-query slider component elements since we've replaced the slides
				this.sliderComponent.slider = this.sliderComponent.querySelector('[id^="Slider-"]');
				this.sliderComponent.scrollbar = this.sliderComponent.querySelector('.slider-scrollbar');
				this.sliderComponent.scrollbarActive = this.sliderComponent.querySelector('.slider-scrollbar__active');
				
				// Reset slider to first position
				if (this.sliderComponent.slider) {
					this.sliderComponent.slider.scrollLeft = 0;
				}
				
				// Now initialize pages with the new elements
				if (this.sliderComponent.initPages) {
					this.sliderComponent.initPages();
				}
			}, 50);
		}

		// Focus management
		if (this.closeButton) {
			this.closeButton.focus();
		}
	}

	close() {
		this.modal.classList.remove('laps-photos-modal--open');
		this.modal.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('overflow-hidden');

		// Return focus to the trigger element
		const triggerElement = document.querySelector(`[data-article-id="${this.currentArticleId}"]`);
		if (triggerElement) {
			const link = triggerElement.querySelector('a') || triggerElement;
			link.focus();
		}

		this.currentArticleId = null;
	}

	isOpen() {
		return this.modal.classList.contains('laps-photos-modal--open');
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new LapsPhotosModal();
	});
} else {
	new LapsPhotosModal();
}
